import { render, staticRenderFns } from "./degreeForm.vue?vue&type=template&id=1d0fb12a&scoped=true"
import script from "./degreeForm.vue?vue&type=script&lang=js"
export * from "./degreeForm.vue?vue&type=script&lang=js"
import style0 from "./degreeForm.vue?vue&type=style&index=0&id=1d0fb12a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fb12a",
  null
  
)

export default component.exports